export default {"src":"/_next/static/media/selfDirected.6dbdaa85.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};